<app-modal-wrapper (cancel)="onCancel()" (save)="onSave()" [options]="options" [isValid]="canSave()">
  <div class="module-editor-container editor-container">
    <form class="module-form admin-form">
      <shared-ui-text-input label="Name" [control]="form?.name"></shared-ui-text-input>
      <shared-ui-textarea label="Description" [control]="form?.description"></shared-ui-textarea>
      <shared-ui-checkbox label="Has Api" [control]="form?.hasApi"></shared-ui-checkbox>
      <shared-ui-text-input label="Api Url" [control]="form?.apiUrl"></shared-ui-text-input>
      <shared-ui-text-input label="Api Key" [control]="form?.apiKey"></shared-ui-text-input>
      <shared-ui-text-input label="Sort Order" [control]="form?.sortOrder"></shared-ui-text-input>
      <shared-ui-checkbox label="Active" [control]="form?.isActive"></shared-ui-checkbox>
      <shared-ui-text-input label="Application Id" [control]="form?.applicationId"></shared-ui-text-input>
    </form>
  </div>
</app-modal-wrapper>
